import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Form, Select, Button, Modal, Spin, Tooltip, Typography, Badge, message, Alert, Space, Popconfirm } from "antd";
import QueueAnim from "rc-queue-anim";
import enquire from "enquire.js";
import axios from "axios";
import moment from "moment";

import { debounce } from 'lodash'; 

import { DESKTOP_DOWN } from "../../config/mediaQueries";

import { API_ERRO_TYPE_CANCEL } from "./../../config/general";

import { timeCardService, columnsService, configService, employeesService, companiesService } from "./../../redux/services";

import * as floatbox from "./../../helpers/floatbox";
import { formatHours, toMinutes } from "./../../helpers/hours";

import {
	DatePickerWithMask,
	UIAvatarLabel,
	UIPageListing,
} from "./../../components";

import UIKpiCards from "./../../components/KpiCards";

import Table from "./Table";

import ModalColumns from "./ModalColumns";
import ModalCreate from "./ModalCreate";
import ModalEdit from "./ModalEdit";
import ModalDiscard from "./ModalDiscard";
import ModalAjustes from "./ModalAjustes";
import ModalBancoAjustes from "./ModalBancoAjustes";
import ModalFilters from "./filters";
import ModalJourneyShow from "../Journeys/show";
import FloatBox from "./floatBox";

import { withRouter } from "react-router-dom";
import { icones_status } from "../../enum/status";
import ModalJustificationRequest from "../TimeCard/ModalJustificationRequests";

const config = {
	title           : "Ponto Diário",
	subtitle        : "Visualize os registros de ponto de todos os funcionários no dia selecionado.",
	icon            : <i className="fal fa-calendar-day" />,
	permissionPrefix: "ponto-diario",
};

const CELL_WIDTH = 80;

const groups = {
	punches : "Registros de ponto",
	results : "Apuração",
	overtime: "Horas extras",
	bank    : "Banco de horas",
};

const overtimePeriodLabel = {
	diurno   : "",
	noturno  : "Not. ",
	intervalo: "Int. ",
};

const summaryPeriods = [
	{ key: "diurno", label: "Diurnas" },
	{ key: "noturno", label: "Noturnas" },
	{ key: "intervalo", label: "Intervalo" },
];

const signClass = (minutes) => minutes < 0 ? "is-negative" : (minutes > 0 ? "is-positive" : "");

class Index extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isDisabled: true,
			isLoading  : false,
			isSearching: false,
			data       : [],
			dataTotal  : {},
			pagination : {
				current : 1,
				pageSize: 50,
				total   : 0,
			},
			// Actions
			columnsModalVisible: false,
			ajustesModalVisible: false,
			bancoAjustesModalVisible: false,
			filtersModalVisible: false,
			activeLoadings     : [],
			// Images
			imagePreviewVisible: false,
			imagePreviewImage: "",
			// Media queries
			desktopDown: false,

			companies: [],
			companiesIsLoading: false,

			employees           : [],
			employeesIsLoading  : false,
			currentEmployeeDepartment: '',

			statusList     : [],
			joinColumns    : [],
			dynamicColumns : [],
			overtimeColumns: [],

			columnsList   : [],
			maxJoinColumns: 0,

			// Filters
			empresa_id: "",
			funcionario_id: "",
			dataDia        : moment(new Date()).format("YYYY-MM-DD"),
			status         : "",
			motivo 	       : "",

			filters        : {
				empresa_id     : null,
				departamento_id: null,
				funcao_id      : null,
				jornada_id     : null,
				funcionario_id : null,
			},

			journeyShowModalVisible: false,
			dailyPoint: true,

			modalJustificationRequests: false,
			justificationRequests: [],
			pontoAjusteRequests: [],
			loadingApproveRequests: false,
			loadingRejectRequests: false,
		};

		this._axiosCancelEmployeesToken   = null;
		this._axiosCancelJustificationRequestToken = null;
		this._axiosCancelPontoAjusteRequestToken = null;
	}

	componentDidMount() {
		this.fetchGetAllStatus();
		if (!this.state.companies.length) {
			this.fetchCompanies(this.loadFirstCompany);
			this.fetchEmployees(null);
		}

		// Listen Media Querie sideBar
		enquire.register(DESKTOP_DOWN, {
			match  : () => {
				this.setState({
					desktopDown: true,
				})
			},
			unmatch: () => {
				this.setState({
					desktopDown: false,
				})
			}
		});
	};

	componentDidUpdate(prevProps, prevState) {
		if (prevState.empresa_id !== this.state.empresa_id) {
			this.fetchEmployees(null);
			this.form.setFieldValue("funcionario_id", null);
		}
	}

	componentWillUnmount() {
		// Unlisten Media Querie sideBar
		enquire.unregister(DESKTOP_DOWN);
	};


	fetchSolicitacoesJustificativas = () => {
		if ( this._axiosCancelJustificationRequestToken ) {
			this._axiosCancelJustificationRequestToken.cancel("Only one request allowed at a time.");
		}

		const { 
			funcionario_id, 
			empresa_id,
			dataDia
		} = this.state;

		console.log(this.state)

		if (!empresa_id) return;

		this._axiosCancelJustificationRequestToken = axios.CancelToken.source();

		const dataDiaFormatted = moment(dataDia).format('YYYY-MM-DD');

		timeCardService.listarSolicitacoesJustificativa({
			funcionario_id,
			empresa_id,
			data_inicio: dataDiaFormatted,
			data_fim: dataDiaFormatted,
			cancelToken: this._axiosCancelJustificationRequestToken,
		}).then((data) => {
			this.setState({
				justificationRequests: data.data,
			})
		}).catch((error) => {
			if( error.error_type === API_ERRO_TYPE_CANCEL ) return null;

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(error),
			});
		})
	}

	approveAllJustificationRequest = (aprove) => {
		const { 
			funcionario_id, 
			empresa_id, 
			dataDia,
			justificationRequests,
			pontoAjusteRequests, 
		} = this.state;

		if (aprove) {
			this.setState({ loadingApproveRequests: true });
		} else {
			this.setState({ loadingRejectRequests: true });
		}

		const dataDiaFormatted = moment(dataDia).format('YYYY-MM-DD');

		if (Array.isArray(justificationRequests) && justificationRequests.length > 0) {
			timeCardService.updateSolicitacaoJustificativa({
				funcionario_id,
				empresa_id,
				atualizar_todas: true,
				data_inicio: dataDiaFormatted,
				data_fim: dataDiaFormatted,
				status_aprovacao: aprove ? 'aprovado' : 'recusado',
			}).then((data) => {
				message.success(`Solicitações de justificativa ${aprove ? 'aprovadas' : 'recusadas'} com sucesso!`);
				if (aprove) {
					this.setState({ loadingApproveRequests: false });
				} else {
					this.setState({ loadingRejectRequests: false });
				}
				this.fetchGetAll(true);
			})
			.catch((error) => {
				this.setState({ 
					loadingApproveRequests: false,
					loadingRejectRequests: false,
				});

				if( error.error_type === API_ERRO_TYPE_CANCEL ) return null;

				Modal.error({
					title  : "Ocorreu um erro!",
					content: String(error),
				});
			})
		}

		if (Array.isArray(pontoAjusteRequests) && pontoAjusteRequests.length > 0) {
			timeCardService.updateSolicitacaoPontoAjuste({
				funcionario_id,
				empresa_id,
				atualizar_todas: true,
				data_inicio: dataDiaFormatted,
				data_fim: dataDiaFormatted,
				status_aprovacao: aprove ? 'aprovado' : 'recusado',
			}).then((data) => {
				message.success(`Solicitações de justificativa ${aprove ? 'aprovadas' : 'recusadas'} com sucesso!`);
				if (aprove) {
					this.setState({ loadingApproveRequests: false });
				} else {
					this.setState({ loadingRejectRequests: false });
				}
				this.fetchGetAll(true);
			})
			.catch((error) => {
				this.setState({ 
					loadingApproveRequests: false,
					loadingRejectRequests: false,
				});

				if( error.error_type === API_ERRO_TYPE_CANCEL ) return null;

				Modal.error({
					title  : "Ocorreu um erro!",
					content: String(error),
				});
			})
		}
	}

	justificationRequestsClose = (fetchJustifications, fetchTimeCard) => {
		this.setState({ modalJustificationRequests: false });

		if (fetchTimeCard) this.fetchGetAll(true);
		if (fetchJustifications) {
			this.fetchSolicitacoesJustificativas();
			this.fetchSolicitacoesPontoAjuste();
		}
	}

	
	fetchSolicitacoesPontoAjuste = () => {
		if ( this._axiosCancelJustificationRequestToken ) {
			this._axiosCancelJustificationRequestToken.cancel("Only one request allowed at a time.");
		}

		const { 
			funcionario_id, 
			empresa_id,
			dataDia,
		} = this.state;

		if (!empresa_id) return;

		const dataDiaFormatted = moment(dataDia).format('YYYY-MM-DD');

		this._axiosCancelJustificationRequestToken = axios.CancelToken.source();

		timeCardService.listarSolicitacoesPontoAjuste({
			funcionario_id,
			empresa_id,
			data_inicio: dataDiaFormatted,
			data_fim: dataDiaFormatted,
			cancelToken: this._axiosCancelJustificationRequestToken,
		}).then((data) => {
			this.setState({
				pontoAjusteRequests: data.data,
			})
		}).catch((error) => {
			if( error.error_type === API_ERRO_TYPE_CANCEL ) return null;

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(error),
			});
		})
	}

	hasJustificationRequest = (funcionario_id, id) => {
		const { justificationRequests, pontoAjusteRequests } = this.state;
		
		const hasPontoAjusteRequest = pontoAjusteRequests.some(item => item.cartao_ponto_id === id)

		const hasJustificationRequests = justificationRequests.some(item => item.funcionario_id === funcionario_id);

		return hasPontoAjusteRequest || hasJustificationRequests;
	}

	fetchCompanies = (callback) => {
		if( this._axiosCancelCompaniesToken )
		{
			this._axiosCancelCompaniesToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelCompaniesToken = axios.CancelToken.source();

		this.setState({
			companiesIsLoading: true,
		});

		companiesService.getAutocomplete({
			orderBy    : "nome:asc",
			cancelToken: this._axiosCancelCompaniesToken.token,
		})
		.then((response) => {
			this.setState({
				companiesIsLoading: false,
				companies: response.data.data,
			}, () => {
				if (typeof callback === 'function') {
					callback();
				}
			});
		})
		.catch((data) => {
			if( data.error_type === API_ERRO_TYPE_CANCEL ) return null;

			this.setState({
				companiesIsLoading: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	loadFirstEmployee = () => {
		const { employees } = this.state;
		const [employee] = employees;
		this.selectEmployee(employee?.id);
	}

	selectEmployee = (funcionario_id) => {
		const { employees } = this.state;
		const currentIndex = employees.findIndex((employee) => employee.id === funcionario_id);

		if (this.form && this.form.setFieldValue) {
			this.form.setFieldValue("funcionario_id", funcionario_id);
		}

		this.setState({
			funcionario_id,
			currentEmployeeDepartment: employees[currentIndex]?.contrato[0]?.departamento_id,
		}, () => {
			this.fetchGetAll(true);
		});
	}

	fetchEmployees = debounce((value, callback) => {
		if( this._axiosCancelEmployeesToken )
		{
			this._axiosCancelEmployeesToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelEmployeesToken = axios.CancelToken.source();
		/*
		if( !value.trim().length )
		{
			this.setState({
				employeesIsLoading: false,
				employees         : [],
			});

			return false;
		}
		*/
		const { filters } = this.state;

		const empresa_id      = this.state.empresa_id;
		const departamento_id = filters.departamento_id;
		const jornada_id      = filters.jornada_id;
		const funcao_id       = filters.funcao_id;

		this.setState({
			employeesIsLoading: true,
		});

		let params = {
			search     : value,
			orderBy    : "nome:asc",
			cancelToken: this._axiosCancelEmployeesToken.token,
		};

		if(empresa_id) {
			params.empresas_ids = [empresa_id];
		}

		if(departamento_id) {
			params.departamentos_ids = [departamento_id];
		}

		if(jornada_id) {
			params.horarios_ids = [jornada_id];
		}

		if(funcao_id) {
			params.funcao_ids = [funcao_id];
		}

		employeesService.getAutocomplete({
			...params,
		})
		.then((response) => {
			this.setState({
				employeesIsLoading: false,
				employees         : response.data.data,
			}, ()=> {
				if (callback) callback();			
			});

		})
		.catch((data) => {
			if( data.error_type === API_ERRO_TYPE_CANCEL ) return null;

			this.setState({
				employeesIsLoading: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	}, 500);

	loadFirstCompany = () => {
		const { companies } = this.state;
		const [company] = companies;
		this.selectCompany(company?.id);
	}

	selectCompany = (empresa_id) => {
		const { companies } = this.state;
		const currentIndex = companies.findIndex((company) => company.id === empresa_id);

		if (this.form && this.form.setFieldValue) {
			this.form.setFieldValue("empresa_id", empresa_id);
		}

		this.setState({
			empresa_id,
			funcionario_id: null,
			isPreviousDisabled: currentIndex <= 0,
			isNextDisabled: currentIndex >= (companies.length - 1),
		}, () => {
			this.fetchGetAll(true);
		});
	}

	fetchGetAllStatus = () => {
		configService.getAllTimeCardStatus()
		.then((response) => {
			this.setState({
				statusList: response.data.data,
			});
		})
		.catch((data) => {
			if( data.error_type === API_ERRO_TYPE_CANCEL ) return null;

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	}

	resetTable = (isSearching = false) => {
		this.setState((state) => ({
			data: [],
			isLoading: false,
			isDisabled: isSearching,
			isSearching,
			pagination : { 
				...state.pagination, 
				current: 1, 
				total  : 0 
			} 
		}));
	}

	fetchGetAll = async (paginate = false) => {
		const  { pagination, dataDia, status, filters, empresa_id, funcionario_id } = this.state;

		// Hide all floatbox
		floatbox.hideAll();

		this.setState({ isDisabled: true, isLoading: true, isSearching: true }, () => {

			const data = {
				funcionario_id: funcionario_id || null,
				data          : dataDia,
				status,
				empresa_id: empresa_id || null,
				departamento_id: filters?.departamento_id || null,
				funcao_id: filters?.funcao_id || null,
				jornada_id: filters?.jornada_id || null,
				page: paginate ? pagination.current : 1,
				limit: pagination.pageSize,
			}
			
			if (!paginate) this.resetTable(true);

			timeCardService.getAllDailyPoint(data)
				.then((response) => {
					this.setState(state => ({
						// isLoading  : false,
						// isSearching: true,
						data       :
							response.data?.data?.map((item) => ({
									...item,
									_ajuste_horas_falta: this.formatTime(item.ajuste_horas_falta),
									possui_batidas: this.checkBatidas(item),
								}
							)),
						pagination : {
							...state.pagination,
							current: response.data?.meta?.current_page,
							total  : response.data?.meta?.total,
						},
					}), () => {
						this.onHandle(response, data, paginate);
					});
				})
				.catch((data) => {
					this.resetTable();
					Modal.error({
						title  : "Ocorreu um erro!",
						content: String(data),
					});
				});
		});

		this.fetchSolicitacoesJustificativas();
		this.fetchSolicitacoesPontoAjuste();
	};

	onHandle = async (response, dataQuery, paginate = false) => {
		const { funcionario_id: funcionario_id_original, ...restDataQuery } = dataQuery;
		const { funcionario_id } = this.state;
		const data = {
			...restDataQuery,
			funcionario_id
		}

		const { data: elements, totais } = response.data || {}
		const [element] = elements || [];

		if( elements?.length > 0 ) {
			columnsService.show({empresa_id: data.empresa_id || element?.contrato?.empresa_id})
				.then((response) => {
					this.setState({
						columnsList: response.data.data[0],
					}, () => {
						this.getJoinColumns(paginate);
						this.getDynamicColumns();
						this.getOvertimeColumns();

						this.onTotal(totais);
					});
				})
				.catch((data) => {
					this.setState({
						isLoading  : false,
						isDisabled: false,
					});
					Modal.error({
						title  : "Ocorreu um erro!",
						content: String(data),
					});
				});
			return;
		}

		this.setState({
			isLoading  : false,
			isDisabled: false ,
			dataTotal  : {},
		});
	}

	onTotal = (totais) => {
		this.setState({
			dataTotal: {
				...totais,
				_total_ajustado: this.formatTime(totais?.total_ajustado),
			},
			isLoading : false,
			isDisabled: false,
		});
	}

	onPaginationChange = (page, pageSize) => {
		this.setState(state => ({
			pagination: {
				...state.pagination,
				current: page,
				pageSize,
			},
		}), () => {
			this.fetchGetAll(true);
		});
	};

	formatTime = (time) => {
		if( time < 0 )
		{
			return `-${moment().startOf("day").add(Math.abs(time), "minutes").format("HH:mm")}`;
		}

		return moment().startOf("day").add(time, "minutes").format("HH:mm");
	}

	checkBatidas = (item) => {
		const batidas = item.cartaopontobatida;

		for (let i = 0; i < batidas.length; i++) {
			const batida = batidas[i];

			if (batida.entrada_batida !== null && batida.entrada_batida !== "00:00") {
				return true;
			}

			if (batida.saida_batida !== null && batida.saida_batida !== "00:00") {
				return true;
			}
		}

		return false;
	}

	columnsOpen = () => {
		const empresa_id = this.state.data[0]?.contrato?.empresa_id || this.form.getFieldValue("empresa_id") || 0;

		if( !isNaN(empresa_id) && empresa_id > 0 )
		{
			this.setState({columnsModalVisible: true});

			// On open screen
			this.columnsScreen.onOpen(empresa_id);
		}
		else
		{
			Modal.error({
				title  : "Ocorreu um erro!",
				content: "Selecione uma empresa para gerenciar as colunas.",
			});
		}
	};

	columnsOnClose = () => {
		this.setState({columnsModalVisible: false});
	}

	columnsOnComplete = () => {
		this.setState({columnsModalVisible: false});
		this.form.submit();
	}

	journeyOpen = (journeyId) => {
		if (journeyId) {
			this.setState({ journeyShowModalVisible: true });

			// On open screen
			this.journeyShowScreen.onOpen(journeyId);
		} else {
			Modal.warning({
				title: "Ação Necessária!",
				content: "Identifique um funcionário na seleção 'Funcionário' para obter os detalhes da jornada.",
			});
		}
	}

	ajustesOpen = (item) => {
		this.setState({ ajustesModalVisible: true });

		// On open screen
		this.ajustesScreen.onOpen(item);
	};

	ajustesOnClose = () => {
		this.setState({ ajustesModalVisible: false });
	}

	ajustesOnComplete = (item) => {
		this.setState({ ajustesModalVisible: false });
		this.updateRow(item);
	}

	bancoAjustesOpen = (item) => {
		this.setState({ bancoAjustesModalVisible: true });

		// On open screen
		this.bancoAjustesScreen.onOpen(item);
	};

	bancoAjustesOnClose = () => {
		this.setState({ bancoAjustesModalVisible: false });
	}

	bancoAjustesOnComplete = (row) => {
		const { data = [] } = this.state;
		this.setState({ bancoAjustesModalVisible: false }, () => {
			const itemIndex = data?.findIndex(item => item?.funcionario_id === row?.id);
			if (!row || itemIndex < 0) return this.fetchGetAll(true);
			this.updateFuncionarioRow(itemIndex, row?.id);
		});
	}

	updateRow = (row) => {
		const { data = [] } = this.state;
		const itemIndex = data?.findIndex(item => item?.id === row?.id);
		if (!row || itemIndex < 0) return this.fetchGetAll(true);
		return this.updateFuncionarioRow(itemIndex, row?.funcionario_id);
	}

	updateFuncionarioRow = async (itemIndex, funcionario_extra_id) => {
		const { pagination, dataDia, status, filters, empresa_id, funcionario_id } = this.state;
		const row = this.state.data[itemIndex];
		if (!row || !funcionario_extra_id) return this.fetchGetAll(true);

		floatbox.hideAll();

		const data = {
			cartao_ponto_id: row.id,
			funcionario_id: funcionario_extra_id,
			funcionarioIdTotais: funcionario_id || null,
			data: dataDia,
			status,
			empresa_id: empresa_id || null,
			departamento_id: filters?.departamento_id || null,
			funcao_id: filters?.funcao_id || null,
			jornada_id: filters?.jornada_id || null,
			page: 1,
			paginaTotais: pagination.current,
			limit: pagination.pageSize,
		};

		try {
			const response = await timeCardService.getAllDailyPoint(data);
			if (this.state.data[itemIndex]?.id !== row.id) return;

			const [item] = response.data?.data || [];
			if (!item) return this.fetchGetAll(true);

			this.setState(prevState => ({
				data: prevState.data.map(current => current.id === row.id ? {
					...item,
					_ajuste_horas_falta: this.formatTime(item.ajuste_horas_falta),
					possui_batidas: this.checkBatidas(item),
				} : current),
			}), () => this.onTotal(response.data?.totais));
		} catch (error) {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(error),
			});
		}
	};

	printOpen = () => {
		const { filters } = this.state;

		const empresa_id      = this.state.empresa_id;
		const departamento_id = filters.departamento_id;
		const jornada_id      = filters.jornada_id;
		const funcao_id       = filters.funcao_id;
		const dataDia         = this.form.getFieldValue("data");
		const status          = this.form.getFieldValue("status");
		const funcionario_id  = this.form.getFieldValue("funcionario_id");

		let params = new URLSearchParams();

		if( empresa_id ) {
			params.set("empresa_id", empresa_id);
		}

		if( departamento_id )
		{
			params.set("departamento_id", departamento_id);
		}

		if( dataDia )
		{
			params.set("data", moment(dataDia).format("YYYY-MM-DD"));
		}

		if( status )
		{
			params.set("status", status);
		}

		if( jornada_id )
		{
			params.set("jornada_id", jornada_id);
		}

		if( funcao_id )
		{
			params.set("funcao_id", funcao_id);
		}

		if( funcionario_id )
		{
			params.set("funcionario_id", funcionario_id);
		}

		if (this.columns().length > 27) {
			Modal.info({
				title: 'Limite de colunas excedido!',
				content: (
					<div style={{ textAlign: 'justify' }}>
						O número de colunas de impressão ultrapassou o limite de 26, o que pode comprometer a formatação e a qualidade da impressão. Por favor, ajuste as colunas antes de prosseguir.
					</div>
				),
				maskClosable: false,
				keyboard: false,
				closable: false,
				onOk: () => {
					window.close();
				},
			})
			return;
		}

		window.open(`/impressao/dailypoint?${params.toString()}`, '_blank');
	}

	reloadRow = () => {
		this.form.submit();
	}

	onEditEntradaSaida = (itemId, itemIndex, batidaIndex, sequence, type) => {
		this.editScreen.onOpen(this.state.data[itemIndex], itemIndex, batidaIndex, sequence, type, this.state.maxJoinColumns);
	}

	onChangeEntradaSaida = (value, itemId, itemIndex, batidaIndex, sequence, type, initialValue, deletePressed) => {
		let isEditing = false;
		const batida = this.state.data[itemIndex].cartaopontobatida[batidaIndex];
		let isBatidaOriginal = (type === 'entrada' && this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_registro_entrada_id && !this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_ajuste_entrada_id) ||
			(type === 'saida' && this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_registro_saida_id && !this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_ajuste_saida_id) ||
			(type === 'entrada' && batida?.ponto_ajuste_entrada?.tipo === 'Original' && batida?.ponto_ajuste_entrada?.ponto_registros_id) ||
			(type === 'saida' && batida?.ponto_ajuste_saida?.tipo === 'Original' && batida?.ponto_ajuste_saida?.ponto_registros_id);

		// Se tem a batida escolhida
		if( batidaIndex !== -1 )
		{
			if( !deletePressed && type === 'entrada' && this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_ajuste_entrada_id && !!this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.entrada_batida )
			{
				isEditing = true;
			}
			else if( !deletePressed && type === 'saida' && this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_ajuste_saida_id && !!this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.saida_batida )
			{
				isEditing = true;
			} else {
				if(deletePressed && !isBatidaOriginal) {
					this.setState({
						isLoading: false,
					});

					// Descarta batida direto
					this.discardScreen.onOpen(this.state.data[itemIndex], value, itemIndex, batidaIndex, sequence, type, this.state.motivo, initialValue, deletePressed, true);

					return false;
				}
				if(deletePressed || isBatidaOriginal) {
					this.discardScreen.onOpen(this.state.data[itemIndex], value, itemIndex, batidaIndex, sequence, type, this.state.motivo, initialValue, deletePressed);

					return false;
				}
			}
		}

		if( !isEditing )
		{
			this.createScreen.onOpen(this.state.data[itemIndex], value, itemIndex, batidaIndex, sequence, type, this.state.motivo);

			return false;
		}

		this.setState({
			isLoading: false,
		});

		const data = {
			cartao_ponto_batida_id: this.state.data[itemIndex].cartaopontobatida[batidaIndex].id,
			sequencia             : sequence,
		};

		if( type === 'entrada' )
		{
			data.hora_entrada = value.length ? `${moment(this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_ajuste_entrada.data || this.state.data[itemIndex].data).format("YYYY-MM-DD")} ${value}:00` : '';
			data.motivo_entrada = value.length ? this.state.data[itemIndex].cartaopontobatida[batidaIndex].ponto_ajuste_entrada.motivo : null;
			// if( this.state.data[itemIndex].cartaopontobatida[batidaIndex].saida_batida )
			// {
			// 	data.hora_saida = `${this.state.data[itemIndex].data} ${this.state.data[itemIndex].cartaopontobatida[batidaIndex].saida_batida}:00`;
			// }
		}
		else
		{
			data.hora_saida = value.length ? `${moment(this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_ajuste_saida.data || this.state.data[itemIndex].data).format("YYYY-MM-DD")} ${value}:00` : '';
			data.motivo_saida = value.length ? this.state.data[itemIndex].cartaopontobatida[batidaIndex].ponto_ajuste_saida.motivo : null;
			// if( this.state.data[itemIndex].cartaopontobatida[batidaIndex].entrada_batida )
			// {
			// 	data.hora_entrada = `${this.state.data[itemIndex].data} ${this.state.data[itemIndex].cartaopontobatida[batidaIndex].entrada_batida}:00`;
			// }
		}

		timeCardService.batidaHorarioEdit(data).then((response) => {
			this.setState({
				isLoading: false,
			});

			// Hide all floatbox
			floatbox.hideAll();

			this.updateFuncionarioRow(itemIndex, response.data.data[0].funcionario_id);

			//this.reloadRow(this.state.data[itemIndex].id);
		})
		.catch((data) => {
			if( data.error_type === API_ERRO_TYPE_CANCEL ) return null;

			this.setState({
				isLoading: false,
			});

			// Reset input
			floatbox.resetInput(itemId, itemIndex, sequence, type);

			Modal.error({
				title   : "Ocorreu um erro!",
				content : String(data),
				centered: true,
			});
		});
	}

	createOnComplete = (itemId, itemIndex, sequence, type, row, motivo) => {
		// this.fetchGetAll(true);
		const { joinColumns } = this.state;

		joinColumns.filter((item) => item.index === sequence)?.map((item) => {
			item.original = true;
		});

		this.updateFuncionarioRow(itemIndex, row?.funcionario_id);

		this.setState({
			motivo,
		});
	}

	editOnComplete = (itemId, itemIndex, sequence, type, row) => {
		this.updateFuncionarioRow(itemIndex, row?.funcionario_id);
	}

	discardOnComplete = (itemId, itemIndex, sequence, type, motivo, value, batidaIndex, deletePressed, row) => {
		this.setState({
			isLoading: false,
		});

		// Hide all float box
		floatbox.hideAll();

		this.updateFuncionarioRow(itemIndex, row);

		this.setState({
			motivo,
		}, () => {
			if( deletePressed ) return false;
			this.createScreen.onOpen(itemIndex, value, itemIndex, batidaIndex, sequence, type, this.state.motivo);
		});
	}

	/**
	* Filter
	*/
	filtersOpen = () => {
		this.setState({ filtersModalVisible: true });

		// On open screen
		this.filtersScreen.onOpen({ ...this.state.filters });
	};

	filtersOnClose = () => this.setState({ filtersModalVisible: false });

	filtersOnComplete = (filters) => {
		this.setState({ filtersModalVisible: false });
		this.setState({
			filters: filters,
		}, () => {
			this.fetchEmployees(null, () => {
				const { employees } = this.state;
				const funcionario_id = this.form.getFieldValue("funcionario_id");
				const funcionarioFound = employees.find(item => item.id === funcionario_id);
				if (!funcionarioFound) this.form.setFieldValue("funcionario_id", null);
				// Fetch all
				this.fetchGetAll(true);
			})
		});
	};

	formatBatidaStatus = (item, batida) => {
		// Status individuais
		if( batida )
		{
			if( batida?.ponto_ajustes_justificativa_falta_id && !item?.feriado_id)
			{
				return batida?.ponto_ajustes_justificativa_falta?.justificativa?.nome ?? "Justificativa";
			}
		}

		if( item.possui_batidas ) {
			return null;
		}

		// Status de dia todo
		if(item?.feriado_id)
		{
			return "Feriado";
		}
		else if( item?.pontoajuste?.justificativa_id )
		{
			return item?.pontoajuste?.justificativa?.nome ?? "Justificativa";
		}
		else if( item?.folga )
		{
			return "Folga";
		}
		else if(item?.feriado_id && item?.afastamento_id)
		{
			return item?.afastamento?.justificativa?.nome;
		}
		else if( item?.dia_especial )
		{
			return "";
		}
		else if( item.status === 'dia_sem_jornada' )
		{
			return "";
		}

		if (!item?.pontoajuste?.justificativa_id) {
			return item?.afastamento?.justificativa?.nome;
		}

		return null;
	}

	formatBatidaCanEdit = (item) => {
		if( item.status === 'afastamento' )
		{
			return false;
		}

		return true;
	}

	onGoToEntradaSaida = (to, itemId, itemIndex, batidaIndex, sequence, type) => {
		// this.setState({ isLoading: true });

		const row     = this.state.data[itemIndex];
		const batida  = row.cartaopontobatida[batidaIndex];
		const dataDia = row.data;

		const data = {
			cartao_ponto_id       : row.id,
			cartao_ponto_batida_id: batida.id,
			sequencia             : sequence,
			to                    : to,
			type                  : type,
		};

		if( batida.entrada_batida )
		{
			data.entrada_batida = `${dataDia} ${batida.entrada_batida}:00`;
		}

		if( batida.saida_batida )
		{
			data.saida_batida = `${dataDia} ${batida.saida_batida}:00`;
		}

		if( batida.ponto_ajuste_entrada_id )
		{
			data.ponto_ajuste_entrada_id = batida.ponto_ajuste_entrada_id;
		}

		if( batida.ponto_ajuste_saida_id )
		{
			data.ponto_ajuste_saida_id = batida.ponto_ajuste_saida_id;
		}

		timeCardService.movimentarBatida(data).then((response) => {
			// this.setState({ isLoading: false });

			// Hide all floatbox
			floatbox.hideAll();

			this.updateFuncionarioRow(itemIndex, row?.funcionario_id);
		})
		.catch((data) => {
			if( data.error_type === API_ERRO_TYPE_CANCEL ) return null;

			this.setState({
				isLoading: false,
			});

			// Reset input
			floatbox.resetInput(itemId, itemIndex, sequence, type);

			Modal.error({
				title   : "Ocorreu um erro!",
				content : String(data),
				centered: true,
			});
		});
	}

	getJoinColumns = (pagination) => {
		const {data, maxJoinColumns} = this.state;

		let columns = [];
		let max = 0;

		data.forEach((item) => {
			let totalBatidasJornada = item.jornadadiasemana?.jornada_batidas?.length ?? 0;
			let totalBatidasCartao  = item.cartaopontobatida?.length ?? 0;

			if( totalBatidasJornada )
			{
				// Pega a sequencia do ultima batida, api ja retorna por sequencia asc
				const maxJornada = item.jornadadiasemana.jornada_batidas[totalBatidasJornada - 1].sequencia;

				if( maxJornada > max )
				{
					max = maxJornada;
				}
			}

			if( totalBatidasCartao )
			{
				// Pega a sequencia do ultima batida, api ja retorna por sequencia asc
				const maxBatida = item.cartaopontobatida[totalBatidasCartao - 1].sequencia;

				if( maxBatida > max )
				{
					max = maxBatida;
				}
			}

			if (item?.jornada?.tipo_calculo === 'horista' && max === 0) {
				max = 3;
			}
		});

		if( pagination )
		{
			max = Math.max(max, maxJoinColumns);
		}

		this.setState({
			maxJoinColumns: max,
		});

		[...Array(max).keys()].map((index) => {
			columns.push(
				{
					tag      : 'Entrada ' + (index + 1),
					title    : 'Ent. ' + (index + 1),
					index    : index + 1,
					group    : groups.punches,
					width    : CELL_WIDTH,
					className: "punch",
					original : true,
					render   : (item, row_index) => {
						const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
						const status      = this.formatBatidaStatus(item, batidaIndex === -1 ? null : item.cartaopontobatida[batidaIndex]);
						const canEdit     = this.formatBatidaCanEdit(item);

						let isManualPunchResult = false;

						const isManualPunch = (item, index) => {
							const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
							return isManualPunchResult = batidaIndex !== -1 && (item?.cartaopontobatida[batidaIndex]?.ponto_ajuste_entrada?.tipo === 'inclusao');
						};

						const isPreMarked = (item, index) => {
							const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
							if (isManualPunchResult || item?.cartaopontobatida[batidaIndex]?.ponto_registro_entrada?.tipo === 'Original') return false;

							return batidaIndex !== -1 && item.status !== 'dia_sem_jornada' &&
								(item.cartaopontobatida[batidaIndex].entrada_auto_jornada === 1 && item?.cartaopontobatida[batidaIndex]?.ponto_ajuste_entrada?.tipo === 'Pré-assinalado');
						};

						const fora_perimetro = item.cartaopontobatida?.[batidaIndex]?.ponto_registro_entrada?.fora_perimetro
							?? item.cartaopontobatida?.[batidaIndex]?.ponto_ajuste_entrada?.pontoRegistro?.fora_perimetro;

						return !this.state.isLoading && (
							<div>
								<FloatBox
									canEdit={canEdit}
									onEdit={this.onEditEntradaSaida}
									onChange={this.onChangeEntradaSaida}
									onGoTo={this.onGoToEntradaSaida}
									isManualPunch={isManualPunch(item, index)}
									isPreMarked={isPreMarked(item, index)}
									status={item.status}
									fora_perimetro={fora_perimetro}
									itemId={item.id}
									itemIndex={row_index}
									indexBatida={batidaIndex}
									sequence={index + 1}
									type="entrada"
									canGoToLeft={batidaIndex !== -1 && index > 0}
									canGoToRight={batidaIndex !== -1}
									initialValue={item.cartaopontobatida[batidaIndex]?.entrada_batida ?? status ?? ""}
								/>
							</div>
						)
					}
				},
				{
					tag      : 'Saída ' + (index + 1),
					title    : 'Saí. ' + (index + 1),
					index    : index + 1,
					group    : groups.punches,
					width    : CELL_WIDTH,
					className: "punch",
					original : true,
					render   : (item, row_index) => {
						const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
						const status      = this.formatBatidaStatus(item, batidaIndex === -1 ? null : item.cartaopontobatida[batidaIndex]);
						const canEdit     = this.formatBatidaCanEdit(item);

						let isManualPunchResult = false;

						const isManualPunch = (item, index) => {
							const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
							return isManualPunchResult = batidaIndex !== -1 && (item?.cartaopontobatida[batidaIndex]?.ponto_ajuste_saida?.tipo === 'inclusao');
						};

						const isPreMarked = (item, index) => {
							const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
							if (isManualPunchResult || item?.cartaopontobatida[batidaIndex]?.ponto_registro_saida?.tipo === 'Original') return false;

							return batidaIndex !== -1 && item.status !== 'dia_sem_jornada' &&
								(item.cartaopontobatida[batidaIndex].saida_auto_jornada === 1 && item?.cartaopontobatida[batidaIndex]?.ponto_ajuste_saida?.tipo === 'Pré-assinalado');
						};

						const fora_perimetro = item.cartaopontobatida?.[batidaIndex]?.ponto_registro_saida?.fora_perimetro
							?? item.cartaopontobatida?.[batidaIndex]?.ponto_ajuste_saida?.pontoRegistro?.fora_perimetro;

						return !this.state.isLoading && (
							<div>
								<FloatBox
									canEdit={canEdit}
									onEdit={this.onEditEntradaSaida}
									onChange={this.onChangeEntradaSaida}
									onGoTo={this.onGoToEntradaSaida}
									isManualPunch={isManualPunch(item, index)}
									isPreMarked={isPreMarked(item, index)}
									status={item.status}
									fora_perimetro={fora_perimetro}
									itemId={item.id}
									itemIndex={row_index}
									indexBatida={batidaIndex}
									sequence={index + 1}
									type="saida"
									canGoToLeft={batidaIndex !== -1}
									canGoToRight={batidaIndex !== -1 && index + 1 < max}
									initialValue={item.cartaopontobatida[batidaIndex]?.saida_batida ?? status ?? ""}
								/>
							</div>
						)
					}
				}
			);
		});

		this.setState({
			joinColumns: columns,
		});
	}

	getDynamicColumns = () => {
		const {columnsList} = this.state;
		let columns         = [];

		const column = (title, render, total) => ({
			title,
			group    : groups.results,
			width    : CELL_WIDTH,
			className: "text-center",
			render,
			total    : () => <div>{total(this.state.dataTotal)}</div>,
		});

		const hours = (value) => value === "00:00" ? "" : value;

		if( columnsList?.apuracao_normal )
		{
			columns.push(column('Normal', (item) => <div>{hours(item.horas_normal)}</div>, (total) => total.total_horas_normais));
		}

		if( columnsList?.apuracao_faltas )
		{
			columns.push(column('Faltas', (item) => <div>{hours(item.horas_falta)}</div>, (total) => total.total_horas_faltas));
		}

		if( columnsList?.apuracao_carga )
		{
			columns.push(column('Carga', (item) => <div>{hours(item.carga_horaria_jornada)}</div>, (total) => total.total_horas_carga));
		}

		if( columnsList?.apuracao_atraso )
		{
			columns.push(column('Atraso', (item) => <div>{hours(item.horas_atraso)}</div>, (total) => total.total_horas_atraso));
		}

		if (columnsList?.apuracao_falta_dia) {
			columns.push(column(<div className="flexColumnCustom">Falta<br />Dia</div>, (item) => <div>{item.falta_dia_inteiro ? "1" : ""}</div>, (total) => total.total_falta_dia || "0"));
		}

		if( columnsList?.apuracao_ajuste )
		{
			columns.push(column('Ajuste', (item) => (
				<div className="daily-point-grid-link" onClick={() => this.ajustesOpen(item)}>{hours(item._ajuste_horas_falta)}</div>
			), (total) => total._total_ajustado));
		}

		if( columnsList?.apuracao_dsr )
		{
			columns.push(column('Dsr', (item) => <div>{hours(item.dsr_valor)}</div>, (total) => total.total_dsr));
		}

		if (columnsList?.apuracao_dsr_debito) {
			columns.push(column(<div className="flexColumnCustom">Dsr<br />Déb.</div>, (item) => <div>{hours(item.dsr_debito)}</div>, (total) => total.total_dsr_debito));
		}

		if (columnsList?.apuracao_dsr_debito_dia) {
			columns.push(column(<div className="flexColumnCustom">Dsr<br />Déb. Dia</div>, (item) => <div>{item.dsr_debito_dia || ""}</div>, (total) => total.total_dsr_debito_dia));
		}

		if (columnsList?.apuracao_adiconal_noturno) {
			columns.push(column(<div className="flexColumnCustom">Adic.<br />Noturno</div>, (item) => <div>{hours(item.adicional_noturno)}</div>, (total) => total.total_adiconal_noturo));
		}

		if( columnsList?.apuracao_abono )
		{
			columns.push(column('Abono', (item) => <div>{hours(item.horas_abono)}</div>, (total) => total.total_abono));
		}

		if (columnsList?.apuracao_interjornada) {
			columns.push(column('Interj.', (item) => <div>{hours(item.interjornada_debito)}</div>, (total) => total.total_interjornada_debito));
		}

		if( columnsList?.apuracao_extra )
		{
			columns.push(column('Extra', (item) => <div>{hours(item.horas_extra)}</div>, (total) => total.total_horas_extras));
		}

		this.setState({
			dynamicColumns: columns,
		});
	}

	overtimeTotal = (idsFaixa) => {
		const totals = this.state.dataTotal?.horas_extras ?? {};
		const key    = Object.keys(totals).find((id) => idsFaixa.includes(parseInt(id)));

		return key ? totals[key] : "00:00";
	}

	bankTotal = (key) => {
		const value = this.state.dataTotal?.[key] || "";

		return (
			<div className={value.startsWith('-') ? 'colorBDeb' : 'colorBCred'}>
				{value ? value.split(':').slice(0, 2).join(':') : "00:00"}
			</div>
		);
	}

	getOvertimeColumns = () => {
		const { data, columnsList } = this.state;
		let columns               = [];
		const filteredDataUsaBancoHoras = data.filter(item => item.usa_banco_horas === 1);
		// hora_extra_diurna
		// hora_extra_intervalo
		// hora_extra_noturna
		data.forEach((item) => {
			(item.hora_extra?.hora_extra_dados ?? []).forEach((dados) => {
				dados.hora_extra_faixas.forEach((faixa) => {
					const index = columns.findIndex((column) => column.percentual === faixa.percentual && column.periodo === dados.periodo);
					if( index === -1 )
					{
						if( (columnsList?.hora_extra_diurna && dados.periodo === "diurno") || (columnsList?.hora_extra_intervalo && dados.periodo === "intervalo") || (columnsList?.hora_extra_noturna && dados.periodo === "noturno") )
						{
							columns.push(
								{
									idsFaixa  : [faixa.id],
									percentual: faixa.percentual,
									periodo   : dados.periodo,
									title     : `${overtimePeriodLabel[dados.periodo] ?? ""}${parseFloat(faixa.percentual)}%`,
									group     : groups.overtime,
									width     : CELL_WIDTH,
									className : "text-center",
								},
							);
						}
					}
					else
					{
						columns[index].idsFaixa.push(faixa.id);
					}
				});
			});
		});
		columns.forEach((column) => {
			column.render = (item) => {
				let value = "";
				item.cartaopontohorasextras.forEach((extra) => {
					if( column.idsFaixa.includes(extra.horas_extras_faixa_id) )
					{
						value = extra.quantidade;
						return false;
					}
				});
				return (
					<div>{value}</div>
				)
			};
			column.total = () => <div>{this.overtimeTotal(column.idsFaixa)}</div>;
		});
		if( columnsList?.banco_hora && filteredDataUsaBancoHoras.length > 0)
		{
			columns.push({
				title    : 'BCréd',
				group    : groups.bank,
				width    : CELL_WIDTH,
				total    : () => this.bankTotal('bh_horas_extras'),
				className: "text-center colorBCred",
				render: (item) => <div>{item.horas_banco_extras === "00:00" ? "" : item.horas_banco_extras}</div>
			});
			columns.push({
				title    : 'BDéb',
				group    : groups.bank,
				width    : CELL_WIDTH,
				total    : () => this.bankTotal('bh_horas_falta'),
				className: "text-center colorBDeb",
				render: (item) => <div>{item.horas_banco_falta === "00:00" ? "" : item.horas_banco_falta}</div>
			});
			columns.push({
				title    : 'BTotal',
				group    : groups.bank,
				width    : CELL_WIDTH,
				total    : () => this.bankTotal('bh_horas_total'),
				className: "text-center",
				render: (item) => {
					const isNegative = item.horas_banco_total?.startsWith('-');
					const colorClass = isNegative ? "colorBDeb" : "colorBCred";
					return (
						<div className={`${colorClass}`}>
							{item.horas_banco_total === "00:00" ? "" : item.horas_banco_total}
						</div>
					);
				}
			});
			columns.push({
				title    : 'BSaldo',
				group    : groups.bank,
				width    : CELL_WIDTH,
				total    : () => this.bankTotal('bh_horas_saldo'),
				className: "text-center",
				render: (item) => {
					const isNegative = item.horas_banco_saldo?.startsWith('-');
					const colorClass = isNegative ? "colorBDeb" : "colorBCred";
					return (
						<div className={`${colorClass}`}>
							{item.horas_banco_saldo === "00:00" ? "00:00" : item.horas_banco_saldo}
						</div>
					);
				}
			});
			columns.push({
				title    : 'BAjuste',
				group    : groups.bank,
				width    : CELL_WIDTH,
				total    : () => this.bankTotal('bh_horas_ajuste'),
				className: "text-center",
				render: (item) => {
					const isNegative = item.horas_banco_ajustes?.startsWith('-');
					const colorClass = isNegative ? "colorBDeb" : "colorBCred";
					return (
						<div
							className={`daily-point-grid-link ${colorClass}`}
							onClick={() => this.bancoAjustesOpen(item)}
						>
							<div>{item.horas_banco_ajustes === "00:00" ? "" : item.horas_banco_ajustes}</div>
						</div>
					);
				}
			});
		}
		this.setState({
			overtimeColumns: columns,
		});
	}

	columns = () => {
		return [
			{
				title    : 'Funcionário',
				width    : 280,
				className: "employee",
				render   : (item, row_index, row) => {
					const avatar      = item?.funcionario?.avatar;
					const status      = icones_status[item?.status];
					const archived    = item?.contrato?.arquivar === 1;
					const pending     = this.hasJustificationRequest(item?.funcionario_id, item?.id);
					const statusTitle = this.getStatusTitle(item);

					return (
						<div className={`daily-point-employee ${pending ? "is-pending" : ""}`}>
							<div className={`daily-point-employee-avatar ${avatar ? "is-clickable" : ""}`} onClick={() => avatar && this.onImagePreview(avatar)}>
								<UIAvatarLabel id={item?.funcionario_id} name={item?.funcionario?.nome} avatar={avatar} showName={false} />
							</div>
							<Typography.Text ellipsis={{ tooltip: item?.funcionario?.nome }} className="daily-point-employee-name">
								{item?.funcionario?.nome ?? "-"}
							</Typography.Text>
							{pending && (
								<Tooltip title="Justificativa e/ou marcação manual pendente de aprovação">
									<i className="fas fa-clock daily-point-employee-pending" />
								</Tooltip>
							)}
							<Tooltip title={archived ? `${statusTitle} · Dia referente a contrato arquivado e não poderá ser editado!` : statusTitle}>
								<span className="daily-point-employee-status-wrap">
									<button type="button" className="daily-point-employee-status" disabled={archived} onClick={row?.openActions}>
										{status && <i className={`fas ${status.icon}`} style={{ color: item?.status_cor }} />}
										<i className="far fa-chevron-down daily-point-employee-chevron" />
									</button>
								</span>
							</Tooltip>
						</div>
					);
				}
			},
			{
				title: 'Previsto',
				width: 110,
				className: "previsto",
				render: (item) => {
					const hasThirdJourney = item?.jornadadiasemana?.jornada_batidas[2]?.entrada;
					const journeyList = item?.jornadadiasemana?.jornada_batidas;
					let journeyListToShow = [];

					if (hasThirdJourney) {
						const [firstJourney, secondJourney] = journeyList;
						journeyListToShow = [firstJourney, secondJourney];
					} else if (journeyList?.length > 0) {
						journeyListToShow = journeyList;
					}

					const journeyRender = (lista, isTooltip) => {
            return (
              <div>
                {lista.map((batida, index) => {
                  if (!batida.entrada || !batida.saida) {
                    return null;
                  }

                  const shouldDisplay =
                    !item?.folga && !item?.feriado_id && !item?.dia_especial;

                  return (
                    <Fragment key={index}>
                      <span
                        style={{ display: shouldDisplay ? "inline" : "none" }}
                      >
                        {batida.entrada} - {batida.saida}
                      </span>
                      <br />
                    </Fragment>
                  );
                })}
                {hasThirdJourney && !isTooltip && (
                  <div className="overflow_journey_indicator">...</div>
                )}
              </div>
            );
          };

					return (
            <div className="inner">
              <Tooltip
                title={
                  hasThirdJourney
                    ? journeyRender(journeyList, true)
                    : ""
                }
              >
                {journeyRender(journeyListToShow)}
              </Tooltip>
            </div>
          );
				}
			},
			...this.state.joinColumns,
			// {
			// 	title      : null,
			// 	titleRender: <Button type="primary" shape="circle" icon={<i className="far fa-plus" />} onClick={this.newJoinColumn}></Button>,
			// 	className  : "last-column",
			// 	width      : 40,
			// 	render     : () => <Fragment></Fragment>
			// },
			...this.state.dynamicColumns,
			...this.state.overtimeColumns,
		]
	}

	getStatusTitle = (row) => {
		if (row?.status_nome === 'Dia sem jornada') {
			return 'Dia sem horário'
		}

		return row?.status_nome ?? ""
	}

	newJoinColumn = () => {
		const {isSearching, joinColumns} = this.state;
		let index                        = joinColumns.length / 2;

		if( isSearching )
		{
			joinColumns.push(
				{
					tag      : 'Entrada ' + (index + 1),
					title    : 'Ent. ' + (index + 1),
					index    : index + 1,
					group    : groups.punches,
					width    : CELL_WIDTH,
					className: "punch",
					original : false,
					render   : (item, row_index) => {
						const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
						const status      = this.formatBatidaStatus(item, batidaIndex === -1 ? null : item.cartaopontobatida[batidaIndex]);
						const canEdit     = this.formatBatidaCanEdit(item);

						return !this.state.isLoading && (
							<div>
								<FloatBox
									canEdit={canEdit}
									onEdit={this.onEditEntradaSaida}
									onChange={this.onChangeEntradaSaida}
									onGoTo={this.onGoToEntradaSaida}
									itemId={item.id}
									itemIndex={row_index}
									indexBatida={batidaIndex}
									sequence={index + 1}
									type="entrada"
									canGoToLeft={batidaIndex !== -1 && index > 0}
									canGoToRight={batidaIndex !== -1}
									initialValue={status ?? item.cartaopontobatida[batidaIndex]?.entrada_batida ?? ""}
								/>
							</div>
						)
					}
				},
				{
					tag      : 'Saída ' + (index + 1),
					title    : 'Saí. ' + (index + 1),
					index    : index + 1,
					group    : groups.punches,
					width    : CELL_WIDTH,
					className: "punch",
					original : false,
					render   : (item, row_index) => {
						const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
						const status      = this.formatBatidaStatus(item, batidaIndex === -1 ? null : item.cartaopontobatida[batidaIndex]);
						const canEdit     = this.formatBatidaCanEdit(item);

						return !this.state.isLoading && (
							<div>
								<FloatBox
									canEdit={canEdit}
									onEdit={this.onEditEntradaSaida}
									onChange={this.onChangeEntradaSaida}
									onGoTo={this.onGoToEntradaSaida}
									itemId={item.id}
									itemIndex={row_index}
									indexBatida={batidaIndex}
									sequence={index + 1}
									type="saida"
									canGoToLeft={batidaIndex !== -1}
									canGoToRight={batidaIndex !== -1 && index + 1 < this.state.maxJoinColumns}
									initialValue={status ?? item.cartaopontobatida[batidaIndex]?.saida_batida ?? ""}
								/>
							</div>
						)
					}
				}
			);

			this.setState({
				joinColumns,
				maxJoinColumns: this.state.maxJoinColumns + 1,
			});
		}
		else
		{
			this.form.submit();
		}
	}

	removeBatida = () => {
		const {joinColumns} = this.state;

		if( joinColumns.length > 2 && !joinColumns[joinColumns.length - 1].original )
		{
			joinColumns.pop();
			joinColumns.pop();

			this.setState({
				joinColumns,
				maxJoinColumns: this.state.maxJoinColumns - 1,
			});
		} else {
			message.warning("Não é possível remover colunas originais!");
		}
	}

	addDay = () => {
		const { dataDia } = this.state;

		if (dataDia && moment(dataDia).isValid())
		{
			const newDate = moment(dataDia).add(1, 'day');

			this.form.setFieldsValue({
				data: newDate,
			});

			this.setState({ dataDia: newDate }, () => this.form.submit());
		}
	}

	subDay = () => {
		const { dataDia } = this.state;

		if (dataDia && moment(dataDia).isValid())
		{
			const newDate = moment(dataDia).subtract(1, 'day');
			
			this.form.setFieldsValue({
				data: newDate,
			});

			this.setState({ dataDia: newDate }, () => this.form.submit());
		}
	}

	onFinish = (values) => {
		const { filters } = this.state;

		this.setState({
			departamento_id: filters.departamento_id,
			funcao_id      : filters.funcao_id,
			jornada_id     : filters.jornada_id,
			empresa_id     : values.empresa_id,
			dataDia        : values.data.format("YYYY-MM-DD"),
			status         : values.status,
		}, () => {
			this.selectEmployee(values.funcionario_id);
		});
	};

	/**
 	 * Image preview
	 */
	onImagePreviewClose = () => this.setState({ imagePreviewVisible: false });

	onImagePreview = (url) => {
		this.setState({
			imagePreviewImage: url,
			imagePreviewVisible: true,
		});
	};

	journeyOnClose = () => {
		this.setState({ journeyShowModalVisible: false });

		document.querySelector(".ant-modal-wrap").focus();
	};

	dayBalance = () => {
		const { dataTotal } = this.state;

		return toMinutes(dataTotal?.total_horas_extras) - toMinutes(dataTotal?.total_horas_faltas);
	}

	kpis = () => {
		const { dataTotal } = this.state;
		const hasTotals     = Object.keys(dataTotal ?? {}).length > 0;
		const value         = (key) => hasTotals ? formatHours(toMinutes(dataTotal[key])) : null;
		const balance       = this.dayBalance();

		return [
			{
				key    : "normal",
				tone   : "blue",
				icon   : <i className="fal fa-clock" />,
				title  : "Horas trabalhadas",
				value  : value("total_horas_normais"),
				caption: "Total do dia",
			},
			{
				key    : "extra",
				tone   : "green",
				icon   : <i className="fal fa-chart-line" />,
				title  : "Horas extras",
				value  : value("total_horas_extras"),
				caption: "Total do dia",
			},
			{
				key    : "faltas",
				tone   : "red",
				icon   : <i className="fal fa-calendar-times" />,
				title  : "Faltas",
				value  : value("total_horas_faltas"),
				caption: "Total do dia",
			},
			{
				key    : "noturno",
				tone   : "violet",
				icon   : <i className="fal fa-moon" />,
				title  : "Adicional noturno",
				value  : value("total_adiconal_noturo"),
				caption: "Total do dia",
			},
			{
				key    : "abono",
				tone   : "amber",
				icon   : <i className="fal fa-umbrella" />,
				title  : "Abono",
				value  : value("total_abono"),
				caption: "Total do dia",
			},
			{
				key    : "saldo",
				tone   : balance < 0 ? "red" : (balance > 0 ? "green" : "neutral"),
				icon   : <i className="fal fa-balance-scale" />,
				title  : "Saldo do dia",
				value  : hasTotals ? formatHours(balance) : null,
				caption: "Extras - Faltas",
			},
		];
	}

	renderFilters = () => {
		const {
			isDisabled,
			isLoading,
			statusList,
			employees,
			employeesIsLoading,
			dataDia,
			empresa_id,
			companies,
			funcionario_id,
			filters,
		} = this.state;

		const excludeKeys  = ['pendente_dia_atual', 'falta'];
		const filtersCount = [filters.departamento_id, filters.funcao_id, filters.jornada_id].filter(Boolean).length;

		return (
			<Form
				ref={el => this.form = el}
				layout="vertical"
				className="daily-point-filters"
				scrollToFirstError
				disabled={isLoading}
				onFinish={this.onFinish}
				initialValues={{
					data: moment(),
				}}
			>
				<Form.Item
					name="empresa_id"
					label="Empresa"
					className="daily-point-filters-company"
					rules={[{ required: true, message: "Campo obrigatório." }]}
				>
					<Select
						allowClear
						filterOption={(input, option) => (typeof option.children === 'string' ? option.children : option.children.props.children).toLowerCase().indexOf(input.toLowerCase()) >= 0}
						notFoundContent={this.state.companiesIsLoading ? <Spin size="small" /> : null}
						onDropdownVisibleChange={(open) => open && this.fetchCompanies()}
						onSearch={this.fetchCompanies}
						onSelect={this.selectCompany}
						optionFilterProp="children"
						placeholder="Selecione a empresa"
						showSearch
						value={empresa_id}
					>
						{companies.map((company, index) => (
							<Select.Option key={index} value={company.id}>
								{company.nome}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item
					name="funcionario_id"
					label="Funcionário"
					className="daily-point-filters-employee"
					rules={[
						{
							required: true,
							validator: (_, value) =>
								value === null || value === "Todos"
								? Promise.resolve()
								: value
									? Promise.resolve()
									: Promise.reject(new Error("Campo obrigatório."))
						}
					]}
				>
					<Select
						filterOption={false}
						allowClear
						placeholder="Selecione o funcionário"
						notFoundContent={employeesIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
						onDropdownVisibleChange={(open) => open && this.fetchEmployees()}
						onSearch={this.fetchEmployees}
						onSelect={this.selectEmployee}
						showSearch
						defaultValue={null}
						value={funcionario_id}
					>
						<Select.Option value={null}>Todos</Select.Option>
						{employees?.map((item, index) => (
							<Select.Option key={index} value={item.id}>{item.nome}</Select.Option>
						))}
					</Select>
				</Form.Item>
				<div className="daily-point-filters-date">
					<DatePickerWithMask
						onChange={() => this.form.submit()}
						value={dataDia}
						label="Data"
						name="data"
						required={true}
						arrows={true}
						addDay={this.addDay}
						subDay={this.subDay}
						disabled={isDisabled}
					/>
				</div>
				<Form.Item name="status" label="Status" className="daily-point-filters-status">
					<Select
						optionFilterProp="children"
						filterOption={(input, option) => option.text.toLowerCase().indexOf(input.toLowerCase()) >= 0}
						allowClear
						placeholder="Selecione o status"
						showSearch>
						{
							statusList?.filter(item => !excludeKeys.includes(item.key)).map((item, index) => (
								<Select.Option key={index} value={item.key} text={item.nome}>
									<i className={`fas ${icones_status[item?.key]?.icon} daily-point-status-option-icon`} style={{ color: item?.cor ?? "#000" }} />
									<span>{item.nome}</span>
								</Select.Option>
							))
						}
					</Select>
				</Form.Item>
				<div className="daily-point-filters-actions">
					<Button
						type="default"
						className="action-btn action-btn-secondary"
						icon={<i className="fal fa-filter" />}
						onClick={this.filtersOpen}
					>
						<Badge count={filtersCount} showZero={false} offset={[8, -5]}>Filtros</Badge>
					</Button>
					<Button
						type="primary"
						htmlType="submit"
						className="action-btn"
						icon={<i className="far fa-search" />}
						loading={isDisabled}
						disabled={isDisabled}
					>
						{isDisabled ? "Consultando" : "Consultar"}
					</Button>
				</div>
			</Form>
		);
	}

	renderSummaryCard = ({ className, icon, tone, title, footerLabel, footerValue, footerClassName, children }) => (
		<section className={`daily-point-summary-card ${className || ""}`}>
			<header className="daily-point-summary-header">
				<span className={`daily-point-summary-icon daily-point-summary-icon-${tone}`}>{icon}</span>
				<h3>{title}</h3>
			</header>
			<div className="daily-point-summary-body">
				{children}
			</div>
			<footer className="daily-point-summary-footer">
				<span>{footerLabel}</span>
				<strong className={footerClassName}>{footerValue}</strong>
			</footer>
		</section>
	)

	renderSummary = () => {
		const { data, dataTotal: totals, columnsList, overtimeColumns } = this.state;

		const overtime = overtimeColumns.filter(column => column.idsFaixa).map(column => ({
			periodo   : column.periodo,
			percentual: `${parseFloat(column.percentual)}%`,
			value     : this.overtimeTotal(column.idsFaixa),
		}));

		const overtimePeriods = summaryPeriods
			.map((period) => ({ ...period, items: overtime.filter((item) => item.periodo === period.key) }))
			.filter((period) => period.items.length);

		const bank = [
			{ key: "credito", title: "BCréd", caption: "Créditos", icon: <i className="fal fa-plus-circle" />, value: totals.bh_horas_extras },
			{ key: "debito", title: "BDéb", caption: "Débitos", icon: <i className="fal fa-minus-circle" />, value: totals.bh_horas_falta },
			{ key: "saldo", title: "BSaldo", caption: "Saldo acumulado", icon: <i className="fal fa-wallet" />, value: totals.bh_horas_saldo },
			{ key: "total", title: "BTotal", caption: "Crédito - débito", icon: <i className="fal fa-balance-scale" />, value: totals.bh_horas_total },
			{ key: "ajuste", title: "BAjuste", caption: "Ajustes manuais", icon: <i className="fal fa-sliders-h" />, value: totals.bh_horas_ajuste },
		].map((item) => {
			const minutes = toMinutes(item.value);

			return {
				...item,
				value: formatHours(minutes),
				tone : minutes < 0 ? "red" : (minutes > 0 ? "green" : "neutral"),
			};
		});

		const resume = [
			{ label: "Carga prevista", value: totals.total_horas_carga },
			{ label: "Horas trabalhadas", value: totals.total_horas_normais },
			{ label: "Horas extras", value: totals.total_horas_extras },
			{ label: "Adicional noturno", value: totals.total_adiconal_noturo },
			{ label: "Abono", value: totals.total_abono },
			{ label: "Faltas", value: totals.total_horas_faltas },
			{ label: "Atrasos", value: totals.total_horas_atraso },
		];

		const showBank  = !!columnsList?.banco_hora && data.some(item => item.usa_banco_horas === 1);
		const bankTotal = toMinutes(totals.bh_horas_total);
		const balance   = this.dayBalance();

		return (
			<div className={`daily-point-summary ${showBank ? "has-bank" : ""}`}>
				{this.renderSummaryCard({
					icon           : <i className="fal fa-stopwatch" />,
					tone           : "blue",
					title          : "Horas extras detalhadas",
					footerLabel    : "Total horas extras",
					footerValue    : formatHours(toMinutes(totals.total_horas_extras)),
					footerClassName: "is-primary",
					children       : overtimePeriods.length > 0 ? (
						<div className="daily-point-summary-groups">
							{overtimePeriods.map((period) => (
								<div key={period.key} className="daily-point-summary-group">
									<span className="daily-point-summary-group-title">{period.label}</span>
									<div className="daily-point-summary-values">
										{period.items.map((item, index) => (
											<div key={index} className="daily-point-summary-value">
												<span>{item.percentual}</span>
												<strong>{item.value}</strong>
											</div>
										))}
									</div>
								</div>
							))}
						</div>
					) : (
						<p className="daily-point-summary-empty">Nenhuma faixa de hora extra no dia.</p>
					),
				})}
				{showBank && this.renderSummaryCard({
					className      : "daily-point-summary-card-bank",
					icon           : <i className="fal fa-layer-group" />,
					tone           : "green",
					title          : "Banco de horas",
					footerLabel    : "Total banco de horas",
					footerValue    : formatHours(bankTotal),
					footerClassName: signClass(bankTotal),
					children       : <UIKpiCards items={bank} />,
				})}
				{this.renderSummaryCard({
					icon           : <i className="fal fa-clipboard-list" />,
					tone           : "violet",
					title          : "Resumo do dia",
					footerLabel    : <>Saldo do dia <small>(extras - faltas)</small></>,
					footerValue    : formatHours(balance),
					footerClassName: signClass(balance),
					children       : (
						<dl className="daily-point-summary-list">
							{resume.map((item) => (
								<div key={item.label}>
									<dt>{item.label}</dt>
									<dd>{formatHours(toMinutes(item.value))}</dd>
								</div>
							))}
						</dl>
					),
				})}
			</div>
		);
	}

	render() {
		const {
			isLoading,
			isSearching,
			data,
			justificationRequests,
			pontoAjusteRequests,
		} = this.state;

		const hasPendingRequests = justificationRequests?.length > 0 || pontoAjusteRequests?.length > 0;

		return (
			<QueueAnim className="site-content-inner">
				<div className="page-content fixed-header daily-point-page" key="1">
					<UIPageListing
						icon={config.icon}
						title={config.title}
						subtitle={config.subtitle}
						kpis={this.kpis()}
						isLoading={isLoading}
						enableSearch={false}
						showListTypeChange={false}
						appendSearch={this.renderFilters()}
						buttons={[
							{
								visible: true,
								type   : "secondary",
								onClick: this.columnsOpen,
								title  : "Gerenciar colunas",
								icon   : <i className="fal fa-columns" />,
							},
							{
								visible: true,
								type   : "secondary",
								onClick: this.printOpen,
								title  : "Imprimir",
								icon   : <i className="fal fa-print" />,
							},
						]}
					>
						{hasPendingRequests && (
							<Alert
								className="daily-point-alert"
								type="warning"
								showIcon
								icon={<i className="fal fa-clock" />}
								message="Há justificativa(s) e/ou marcações pendentes de aprovação"
								action={
									<Space direction="horizontal">
										<Popconfirm
											placement="topRight"
											title="Deseja aprovar todas as solicitações?"
											onConfirm={() => this.approveAllJustificationRequest(true)}
											okText="Sim"
											cancelText="Não"
										>
											<Button size="small">
												Aprovar todas
											</Button>
										</Popconfirm>
										<Button size="small" type="primary" onClick={() => {this.setState({ modalJustificationRequests: true });}}>
											Visualizar
										</Button>
									</Space>
								}
							/>
						)}
						{isSearching && (
							<Table
								onPaginationChange={this.onPaginationChange}
								data={data}
								pagination={this.state.pagination}
								columns={this.columns()}
								dataDia={this.state.dataDia}
								fetchGetAll={this.fetchGetAll}
								updateRow={this.updateRow}
								reloadRow={this.updateRow}
								newJoinColumn={this.newJoinColumn}
								removeBatida={this.removeBatida}
								journeyOpen={this.journeyOpen}
								updateFuncionarioRow={this.updateFuncionarioRow}
								fetchJustifications={() => {
									this.fetchSolicitacoesJustificativas();
									this.fetchSolicitacoesPontoAjuste();
								}}
							/>
						)}
						{isSearching && data.length > 0 && this.renderSummary()}
					</UIPageListing>
				</div>
				<ModalColumns
					ref={el => this.columnsScreen = el}
					visible={this.state.columnsModalVisible}
					onComplete={this.columnsOnComplete}
					onClose={this.columnsOnClose}
				/>
				<ModalCreate
					ref={el => this.createScreen = el}
					onComplete={this.createOnComplete}
				/>
				<ModalEdit
					ref={el => this.editScreen = el}
					onComplete={this.editOnComplete}
				/>
				<ModalDiscard
					ref={el => this.discardScreen = el}
					onComplete={this.discardOnComplete}
				/>
				<ModalAjustes
					ref={el => this.ajustesScreen = el}
					visible={this.state.ajustesModalVisible}
					onComplete={this.ajustesOnComplete}
					onClose={this.ajustesOnClose}
				/>
				<ModalBancoAjustes
					ref={el => this.bancoAjustesScreen = el}
					visible={this.state.bancoAjustesModalVisible}
					onComplete={this.bancoAjustesOnComplete}
					onClose={this.bancoAjustesOnClose}
					empresa_id={this.state.empresa_id}
					funcionario_id={this.state.funcionario_id}
					currentEmployeeDepartment={this.state.currentEmployeeDepartment}
				/>
				<ModalJourneyShow
					ref={el => this.journeyShowScreen = el}
					visible={this.state.journeyShowModalVisible}
					onClose={this.journeyOnClose}
				/>
				<ModalFilters
					ref={el => this.filtersScreen = el}
					visible={this.state.filtersModalVisible}
					onComplete={this.filtersOnComplete}
					onClose={this.filtersOnClose}
				/>
				<Modal wrapClassName="modal-image" visible={this.state.imagePreviewVisible} centered footer={null} destroyOnClose={true} onCancel={this.onImagePreviewClose}>
					<img src={this.state.imagePreviewImage} />
				</Modal>
				{this.state.modalJustificationRequests &&
					<ModalJustificationRequest
						visible={this.state.modalJustificationRequests}
						onClose={this.justificationRequestsClose}
						justificationRequests={this.state.justificationRequests}
						pontoAjusteRequests={this.state.pontoAjusteRequests}
						fetchJustifications={() => {
							this.fetchSolicitacoesJustificativas();
							this.fetchSolicitacoesPontoAjuste();
						}}
						approveJustifications={this.approveAllJustificationRequest}
						loadingApproveAll={this.state.loadingApproveRequests}
						loadingRejectAll={this.state.loadingRejectRequests}
					/>
				}
			</QueueAnim>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		permissions: state.auth.userData.permissions,
	};
};

export default connect(mapStateToProps, null)(withRouter(Index));
